import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getApplicationScoringStatus, pushGaStepEvent } from 'actions/loan';
import LoadingPage from 'components/Credit24/LoanApplication/LoadingPage';
import LoanStepError from 'components/Credit24/LoanApplication/LoanStepError';

const propTypes = {
  getApplicationScoringStatus: PropTypes.func.isRequired,
  loan: PropTypes.object.isRequired,
  pushGaStepEvent: PropTypes.func.isRequired,
};

class ScoringStatusAUContainer extends Component {
  componentDidMount() {
    this.props.getApplicationScoringStatus();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.loan.bankScrapingTimedOut && this.props.loan.bankScrapingTimedOut) {
      this.props.pushGaStepEvent('rejected');
    }
  }

  render() {
    if (this.props.loan.bankScrapingTimedOut) {
      return (
        <LoanStepError
          title={<FormattedHTMLMessage id="scoring.status.timed.out.title" />}
          text={<FormattedMessage id="scoring.status.timed.out.text" />}
        />
      );
    }
    return <LoadingPage />;
  }
}

ScoringStatusAUContainer.propTypes = propTypes;

export default connect(
  null,
  {
    getApplicationScoringStatus,
    pushGaStepEvent,
  }
)(ScoringStatusAUContainer);
